import { Components, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

export const muiInputLabel: Components<Omit<Theme, 'components'>>['MuiInputLabel'] = {
  styleOverrides: {
    root: {
      fontSize: '0.875rem',
      '&.Mui-disabled': {
        color: colors.text[60]
      }
    }
  }
};
